export const WORK_SUGGESTIONS_TASKS_PAGE_SIZE = 12;
export const MAX_SPRINTS_PER_PROJECT = 10;

export const SUGGESTIONS_TYPES = {
	PULL_REQUEST_REVIEW: 'PR_REVIEW',
	PULL_REQUEST_NEEDS_WORK: 'PR_NEEDS_WORK',
	FAILED_DEPLOYMENT: 'DEPLOYMENT_FAILED',
	FAILED_BUILD: 'BUILD_FAILED',
	CRIT_VULN: 'CRIT_VULN',
	BLOCKING_ISSUE: 'BLOCKING_ISSUE',
	AUTO_DEV_JOB_PLAN_SUCCESS: 'AUTO_DEV_JOB_PLAN_SUCCESS',
	PR_COMMENTS: 'PR_COMMENTS',
	COMPASS_ANNOUNCEMENT: 'COMPASS_ANNOUNCEMENT',
	PR_STALE: 'PR_STALE',
} as const;

export const WORKS_SUGGESTIONS_TYPES: Record<
	string,
	(typeof SUGGESTIONS_TYPES)[keyof typeof SUGGESTIONS_TYPES]
> = {
	WorkSuggestionsBuildTask: 'BUILD_FAILED',
	WorkSuggestionsDeploymentTask: 'DEPLOYMENT_FAILED',
	WorkSuggestionsPullRequestReviewTask: 'PR_REVIEW',
	WorkSuggestionsPullRequestNeedsWorkTask: 'PR_NEEDS_WORK',
	WorkSuggestionsCriticalVulnerabilityTask: 'CRIT_VULN',
	WorkSuggestionsBlockingIssueTask: 'BLOCKING_ISSUE',
	WorkSuggestionsAutoDevJobsPlanSuccessTask: 'AUTO_DEV_JOB_PLAN_SUCCESS',
	WorkSuggestionsPRCommentsTask: 'PR_COMMENTS',
	WorkSuggestionsCompassAnnouncementTask: 'COMPASS_ANNOUNCEMENT',
	WorkSuggestionsCodeTabPullRequestStaleTask: 'PR_STALE',
} as const;

export const ARTICLE_ID = '2HtqtVTfYoilHIuYJIGD1T';

export const PERISCOPE_ANALYTICS = 'jira.development';

export const INSIGHT_TYPES = {
	OPEN_PULL_REQUESTS: 'OPEN_PULL_REQUESTS',
	CRITICAL_VULNERABILITIES: 'CRITICAL_VULNERABILITIES',
	DEPLOYMENT_CYCLE_TIME: 'DEPLOYMENT_CYCLE_TIME',
} as const;

export const INSIGHT_TARGET_URLS = {
	OPEN_PULL_REQUESTS: '/code',
	CRITICAL_VULNERABILITIES: '/security?severity=CRITICAL',
	DEPLOYMENT_CYCLE_TIME: '/deployments',
} as const;

// Work suggestions in Jira project
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/WSIJ/queues/custom/1098
export const ENTRYPOINT_ID_WORK_SUGGESTION_IN_JIRA_PROJECT = '3ee47ec5-0b90-447e-87e3-137752a59f8c';

export const FEEDBACK = {
	PERISCOPE: 'jsw.periscope',
} as const;

export const SLACK_HELP_URL = 'https://atlassian.enterprise.slack.com/archives/C07CZ9L6SAW';

export const SECONDS_IN_DAY = 86400;

export const SECONDS_IN_HOUR = 3600;

export const SECONDS_IN_MINUTE = 60;
